<template>
  
<div class="container">
      <h3 class="heading">الشكاوي</h3>

      <form @submit.prevent="postinfo">
        
      
 
<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.number_complaint"  class="alert alert-danger" role="alert"> {{ err.number_complaint[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">رقم البلاغ</label>
  <input type="text"   class="form-control half ltr" id="exampleFormControlInput1" placeholder="ادخل رقم البلاغ " v-model="formdata.number_complaint">
</div>
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.complaint_type"  class="alert alert-danger" role="alert"> {{ err.complaint_type[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> نوع البلاغ</label>
<select class="form-select half" aria-label="Default select example" v-model="formdata.complaint_type">
  <option disabled  selected>اختر نوع البلاغ</option>
   <option  v-for="key in formdata2" :value="key.id">{{key.name}}</option>

</select></div>
</div>



<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.housing_box"  class="alert alert-danger" role="alert"> {{ err.housing_box[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> الوحدة</label>
<select class="form-select half" aria-label="Default select example"  v-model="formdata.housing_box">
  <option disabled  selected>اختر الوحدة</option>
     <option  v-for="key in formdata3" :value="key.id">{{key.name_ar}}</option>

 
</select></div>
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.district"  class="alert alert-danger" role="alert"> {{ err.district[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> الحي</label>
<select class="form-select half" aria-label="Default select example" v-model="formdata.district">
  <option disabled  selected>اختر الحي</option>
    <option  v-for="key in formdata4" :value="key.id">{{key.name_ar}}</option>
 
</select></div>


 
</div>



<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.tiem"  class="alert alert-danger" role="alert"> {{ err.tiem[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">وقت الحادث </label>
  <input type="time" class="form-control half ltr" id="exampleFormControlInput1"  v-model="formdata.tiem">
</div>

  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.date"  class="alert alert-danger" role="alert"> {{ err.date[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">تاريخ الحادث</label>
  <input type="date" class="form-control half ltr" id="exampleFormControlInput1"  v-model="formdata.date">
</div>
</div>

 <div class="mb-3 input-in-con">
            <div v-if="err">
  <div v-if="err.address"  class="alert alert-danger" role="alert"> {{ err.address[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> بجانب</label>
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="ادخل وصف المكان "  v-model="formdata.address">
</div>

<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.presented"  class="alert alert-danger" role="alert"> {{ err.presented[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> الاخ </label>
  <input type="text" class="form-control half" id="exampleFormControlInput1" placeholder="ادخل اسم الاخ  " v-model="formdata.presented" >
</div>
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.clerk"  class="alert alert-danger" role="alert"> {{ err.clerk[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">مقدم البلاغ </label>
  <input type="text" class="form-control half" id="exampleFormControlInput1" placeholder="ادخل اسم مقدم البلاغ "  v-model="formdata.clerk">
</div>

</div>

 <div class="mb-3 input-in-con">
         <div v-if="err">
  <div v-if="err.descr"  class="alert alert-danger" role="alert"> {{ err.descr[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">البلاغ</label>
  <textarea type="text" class="form-control rtl" rows="5" id="exampleFormControlInput1" placeholder="اكتب البلاغ" v-model="formdata.descr">

  </textarea>
</div>

<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.complaint_procedures"  class="alert alert-danger" role="alert"> {{ err.complaint_procedures[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">  اجراء القائد</label>
<select class="form-select half" aria-label="Default select example" v-model="formdata.complaint_procedures">
  <option disabled  selected>اختر اجراء القائد</option>
    <option  v-for="key in formdata5" :value="key.id">{{key.name}}</option>
 
</select></div>

  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.complaint_recipient"  class="alert alert-danger" role="alert"> {{ err.complaint_recipient[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">  ظرف مستلم البلاغ</label>
<select class="form-select half" aria-label="Default select example" v-model="formdata.complaint_recipient">
  <option disabled  selected>اختر ظرف مستلم البلاغ</option>
     <option  v-for="key in formdata6" :value="key.id">{{key.name}}</option>

</select></div>

 
</div>


<div v-for="keey in listt" :key="keey.inc" >



  <h3  class="heading">{{inc}} المتهم </h3>

   <div class="mb-3 input-in-con ">
      <div v-if="err2">
  <div v-if="err2.name"  class="alert alert-danger" role="alert"> {{ err2.name[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> الاسم </label>
  <input ref="first_input" type="text" class="form-control " id="exampleFormControlInput1" placeholder="ادخل اسم المتهم  " v-model="formdata7.name">
</div>

<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.gender"  class="alert alert-danger" role="alert"> {{ err2.gender[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> الجنس </label>
<select class="form-select half" aria-label="Default select example" v-model="formdata7.gender">
  <option disabled  selected>اختر الجنس</option>
  <option  value="1" > ذكر</option>
  <option  value="2" > انثى</option>
 
</select></div>
  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.age"  class="alert alert-danger" role="alert"> {{ err2.age[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> العمر </label>
  <input type="number" class="form-control half" id="exampleFormControlInput1" placeholder="ادخل العمر " v-model="formdata7.age">
</div>

</div>

<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.residence"  class="alert alert-danger" role="alert"> {{ err2.residence[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> محل الاقامة </label>
  <select class="form-select half" aria-label="Default select example" v-model="formdata7.residence">
  <option disabled  selected>اختر محل الاقامة</option>
    <option  v-for="key in formdata3" :value="key.id">{{key.name_ar}}</option>
  </select>
</div>

  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.place_of_birth"  class="alert alert-danger" role="alert"> {{ err2.place_of_birth[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">محل الميلاد </label>
  <select class="form-select half" aria-label="Default select example" v-model="formdata7.place_of_birth">
  <option disabled  selected>اختر محل الميلاد</option>
    <option  v-for="key in formdata3" :value="key.id">{{key.name_ar}}</option>
  </select>
</div>

</div>

<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.education_level"  class="alert alert-danger" role="alert"> {{ err2.education_level[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> المستوى التعليمي </label>
<select class="form-select half" aria-label="Default select example" v-model="formdata7.education_level">
  <option disabled  selected>اختر المستوى</option>
    <option  v-for="key in formdata8" :value="key.id">{{key.name}}</option>
  </select>
  </div>

  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.work"  class="alert alert-danger" role="alert"> {{ err2.work[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label"> العمل </label>
  <input type="text" class="form-control half" id="exampleFormControlInput1" placeholder="ادخل العمل " v-model="formdata7.work">
</div>

</div>


<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.phone_2"  class="alert alert-danger" role="alert"> {{ err2.phone_2[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">2 رقم الهاتف</label>
  <input type="text"  maxlength="13" class="form-control half ltr"  id="exampleFormControlInput1" placeholder=" ادخل رقم الهاتف " v-model="formdata7.phone_2">
</div>
  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.phone_1"  class="alert alert-danger" role="alert"> {{ err2.phone_1[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">رقم الهاتف</label>
  <input type="text"  maxlength="13" class="form-control half ltr" id="exampleFormControlInput1" placeholder="ادخل رقم الهاتف " v-model="formdata7.phone_1">
</div>
</div>

<div v-if="err2">
  <div v-if="err2.status_type"  class="alert alert-danger" role="alert"> {{ err2.status_type[0]}}</div>
</div>
<div class="form-check" v-for="key in formdata9" :value="key.id">
  <input class="form-check-input " type="checkbox"  id="flexCheckDefault"  :value="key.id"  v-model="formdata7.status_type">
  <label class="form-check-label" >
{{key.status}} </label>
</div> 
 
 


<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.party"  class="alert alert-danger" role="alert"> {{ err2.party[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">الاطراف    </label>
<select class="form-select half" aria-label="Default select example" v-model="formdata7.party">
  <option disabled  selected>اختر  الاطراف</option>
  <option  value="1" > المجني عليه</option>
  <option  value="2" > المتهم</option>
  <option  value="3" > مقدم الشكوى</option>
  <option  value="4" > مقدم البلاغ</option>
  </select>
  </div>



  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.marital_status"  class="alert alert-danger" role="alert"> {{ err2.marital_status[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">الحالة الاجتماعية </label>
<select class="form-select half" aria-label="Default select example"  v-model="formdata7.marital_status">
  <option disabled  selected>اختر الحالة الاجتماعية</option>
  <option  value="1" > متزوج</option>
  <option  value="2" > عازب</option>
  </select>
  </div>

  <div class="mb-3 input-in-con half">
      <div v-if="err2">
  <div v-if="err2.nationality"  class="alert alert-danger" role="alert"> {{ err2.nationality[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">الجنسية </label>
<select class="form-select half" aria-label="Default select example" v-model="formdata7.nationality">
  <option disabled  selected>اختر الجنسية</option>
   <option  v-for="key in formdata11" :value="key.id">{{key.name}}</option>

  </select>
  </div>
</div>


<div class="mb-3 input-in-con">
         <div v-if="err2">
  <div v-if="err2.note"  class="alert alert-danger" role="alert"> {{ err2.note[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">ملاحظة</label>
  <textarea type="text" class="form-control rtl" rows="5" id="exampleFormControlInput1" placeholder="اكتب ملاحظة" v-model="formdata7.note">

  </textarea>
</div>

</div>

<div v-if="ShowButton" class="flex last">
  <p @click="shoecom" class="btn btn-primary">اضافة متهم </p>
</div>

<div class="flex last">
  <button ref="AddButton"  class="btn btn-primary">اضافة</button>
</div>
      </form>

  </div>

</template>

<script setup>
import { ref,onMounted } from 'vue'
import  geturl  from "@/comp/geturl";



const formdata = ref({
   number_complaint: null,
        date: "",
        tiem: "",
        address: "",
        presented: "",
        clerk: "",
        descr: "",
        complaint_type: null,
        district: null,
        housing_box: null,
        complaint_recipient: null,
        complaint_procedures: null
})
const formdata7 = ref({
        name: "" ,
        age: null,
        gender: null,
        work: "" ,
        phone_1: "+967",
        phone_2: "",
        party: null,
        note: "",
        complaint: null,
        place_of_birth: null,
        residence: null,
       education_level: null,
        nationality: null,
        marital_status: null,
        status_type: []
            
})
const formdata2 = ref(null)
const formdata3 = ref(null)
const formdata4 = ref(null)
const formdata5 = ref(null)
const formdata6 = ref(null)
const formdata8 = ref(null)
const formdata9 = ref(null)
const formdata10 = ref(null)
const formdata11 = ref(null)
const ShowButton = ref(false)
const AddButton = ref(false)
const first_input = ref(null)

const err=ref(null)
const err2=ref(null)
 const listt = ref( [] )
 const errList = ref( [] )
 const inc = ref( 0 )

onMounted(()=>{
 // get complaint_type
        fetch(geturl()+"complaints/complaint_type/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata2.value = data
        })

  // get housing_box
        fetch(geturl()+"housing_box/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata3.value = data
        })

  // get district
        fetch(geturl()+"district/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata4.value = data
        })

  // get complaint_procedures
        fetch(geturl()+"complaints/complaint_procedures", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata5.value = data
        })

  // get complaint_recipient
        fetch(geturl()+"complaints/complaint_recipient", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata6.value = data
        })

    // get education_level
        fetch(geturl()+"complaints/education_level", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata8.value = data
        })

    // get status_type
        fetch(geturl()+"complaints/status_type", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata9.value = data
        })

     

    // get nationality
        fetch(geturl()+"complaints/nationality/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata11.value = data
        })

})


const postinfo = ()=>{


  fetch(geturl()+"complaints/complaint/", {
         method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(formdata.value)
      })
      .then(res => res.json())
      .then(data => { 
        if(data.error){
          err.value = data.error.details
                  }
      else{
        // show add victims button and disable add complain
        AddButton.value.setAttribute('disabled',true)
        ShowButton.value = true;
        err.value = null

           fetch(geturl()+"complaints/complaint/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata10.value = data
        formdata10.value = formdata10.value.filter((e)=>{
             return e.number_complaint == formdata.value.number_complaint
        })
          formdata7.value.complaint = formdata10.value[0].id
        })
      }
      })

}
const shoecom = () =>{

    if(inc.value >0){
        console.log(formdata7.value)
      fetch(geturl()+"complaints/accused_and_victim/", {
         method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(formdata7.value)
      })
      .then(res => res.json())
      .then(data => { 
        if(data.error){
          err2.value = data.error.details
          console.log(formdata7.value.complaint)
          console.log(err2.value)
                  }
      else{

        formdata7.value ={
         name: "" ,
        age: null,
        gender: null,
        work: "" ,
        phone_1: "+967",
        phone_2: "",
        party: null,
        note: "",
        complaint: formdata10.value[0].id,
        place_of_birth: null,
        residence: null,
       education_level: null,
        nationality: null,
        marital_status: null,
        status_type: []
        }
         err2.value = null
        inc.value = ++inc.value
      }
      })
    }
else{
   listt.value.push({
      
             inc:inc.value,
      name: "",
      document: "",
    gender: "",
    nationality: "",
    number: ''
    }),
    errList.value.push({
       inc: inc.value,
       name: "",
      document: "",
    gender: "",
    nationality: "",
    number: ''
    })
inc.value = ++inc.value

}
   
}
    




</script>

<style>

</style>